import { handleActions } from 'redux-actions';
import { types } from './actions';

const initialState = {
	modal: false,
	loading: {
		search: false
	},
	usuarios: {},
	usuarioEdicao: {},
	showSuccessMsgEdit: false,
	showErrorMsgEdit: false
};

export default handleActions(
	{
		[types.MODAL_EDIT_USER]: (state, action) => ({
			...state,
			modal: action.payload
		}),
		[types.USER_EDIT]: (state, action) => ({
			...state,
			usuarioEdicao: action.payload
		}),
		[types.LOADING]: (state, action) => ({
			...state,
			loading: { ...state.loading, ...action.payload }
		}),
		[types.SEARCH_USERS.SUCCESS]: (state, action) => ({
			...state,
			usuarios: action.payload
		}),
		[types.EDIT_PROFILE_USER.SUCCESS]: (state, action) => ({
			...state,
			modal: false
		}),
		[types.EDIT_PROFILE_USER.FAILURE]: (state, action) => ({
			...state,
			modal: true,
			showErrorMsgEdit: true
		}),
		[types.SHOW_MSG_SUCCESS_EDIT]: (state, action) => ({
			...state,
			showSuccessMsgEdit: action.payload
		})
	},
	initialState
);

const getModal = state => state.perfilUsuario.modal;

const getLoading = state => state.perfilUsuario.loading;

const getUsuarios = state => state.perfilUsuario.usuarios;

const getUsuarioEdicao = state => state.perfilUsuario.usuarioEdicao;

const getShowSuccessMsgEdit = state => state.perfilUsuario.showSuccessMsgEdit;

const getShowErrorMsgEdit = state => state.perfilUsuario.showErrorMsgEdit;

const getListLinked = state => {
	return getUsuarios(state).list || [];
};

const getCurrentPage = state => {
	return getUsuarios(state).page || 0;
};

const getTotalUsuarios = state => {
	return getUsuarios(state).total || 0;
};

const getTotalPaginas = state => {
	return getUsuarios(state).pages || 0;
};

export const selectors = {
	getModal,
	getLoading,
	getUsuarios,
	getUsuarioEdicao,
	getListLinked,
	getCurrentPage,
	getTotalUsuarios,
	getTotalPaginas,
	getShowSuccessMsgEdit,
	getShowErrorMsgEdit
};
